import { Injectable } from '@angular/core';
import {
  PublicDemandInterestFormDetails,
  SendPublicDemandInterestFormPayload,
  SendPublicDemandInterestFormResponse,
} from '@features/public-demand-interest-form/utils/models/public-demand-interest-form.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PublicDemandInterestFormService extends HttpHandler {
  validateDemandInterestForm(demandHash: string): Observable<HttpResponse<PublicDemandInterestFormDetails>> {
    const url: string = environment.apiUrls.demands.interests.validate;
    const params = { hash: demandHash };
    return this.post<HttpResponse<PublicDemandInterestFormDetails>>(url, params);
  }

  sendDemandInterestForm(
    payload: SendPublicDemandInterestFormPayload
  ): Observable<HttpResponse<SendPublicDemandInterestFormResponse>> {
    const url: string = environment.apiUrls.demands.interests.send;
    const formData: FormData = new FormData();
    Object.entries(payload)
      .filter(([, value]) => value)
      .forEach(([key, value]) => {
        formData.append(key, typeof value === 'number' ? value.toString() : value);
      });
    return this.post<HttpResponse<SendPublicDemandInterestFormResponse>>(url, formData, {
      recaptchaAction: 'submit_public_demand_interest_form',
    });
  }
}
